const makedPickRemove = ($container, $form) => {
  const $item = $container.find($('@makedPickRemove'));

  const removePick = ($id) => {
    const $target = $(`#${$id}`);
    $target.trigger('click');
  };

  $(document).on('click', $item, (e) => {
    const $id = $(e.target).data('number');

    if ($id !== undefined) {
      $(e.target).remove();
      removePick($id);
    }
  });
};

export default makedPickRemove;
